import { jsx } from 'react/jsx-runtime';

const sizeMap = {
    large: 32,
    medium: 24,
    small: 16,
};
const SvgAlertCircleOutlined = (props) => (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: sizeMap[props.size || "medium"], height: sizeMap[props.size || "medium"], fill: "none", viewBox: "0 0 24 24" }, props, { children: jsx("path", { fill: props.color || "currentColor", fillRule: "evenodd", d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12m11-5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m-1 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1", clipRule: "evenodd" }) })));

export { SvgAlertCircleOutlined as default };
